import "./SuvaiAbout.scss"
import thali from "../../assets/images/thali.png"
import snacks from "../../assets/images/snacks.png"

const SuvaiAbout = () => {
    const leftCont = [
        {
            "text": "<b>SUVAI FUSION</b> is a vibrant multi-cuisine restaurant based in Mansfield, Nottingham, bringing together the bold flavours of Sri Lankan, Indian, and Indo-Chinese cuisine under one roof."
        },
        {
            "text": " From sizzling kothu roti and aromatic biryanis to crispy dosas, rich curries, and flavour-packed fusion dishes, every plate at SUVAI FUSION is crafted with authentic spices, fresh ingredients, and a passion for true taste."
        },
        {
            "text": " Whether you're joining us for a relaxed family meal, grabbing a quick bite with friends, or ordering your favourites to enjoy at home, SUVAI FUSION delivers unforgettable flavour in every bite.Authentic Taste. Modern Twist. True Fusion."
        }
    ]
    const rightCont = [
        {
            "text": "Our food philosophy celebrates flavours, culture, and creativity from Sri Lankan, Indian, and Indo-Chinese traditions. We believe every dish should be an experience—a perfect harmony of aromas, textures, and tastes that awaken the senses. "
        },
        {
            "text": "By blending authentic culinary techniques with modern twists, we create dishes that are both comforting and adventurous. Fresh, high-quality ingredients form the heart of our kitchen, thoughtfully combined to craft meals that nourish the body and delight the palate. For us, dining is not just about sustenance—it’s about connection, joy, and the simple pleasure of discovering something extraordinary in every bite."
        },
    ]
    return (
        <div className="SuvaiAbout">
            <div className="SuvaiAbout-inner">
                <div className="SuvaiAbout-inner-textContWarpper">
                    <div className="SuvaiAbout-inner-textContWarpper-textCont">
                        {leftCont.map((content, key) => <div
                            key={key}
                            dangerouslySetInnerHTML={{ __html: content?.text }}
                            className="SuvaiAbout-inner-textContWarpper-textCont-content" />)}
                    </div>
                </div>
                <div
                    className="SuvaiAbout-inner-imageCont"
                    style={{
                        backgroundImage: `linear-gradient(180deg, rgba(16, 18, 19, 0) 0%, rgba(16, 18, 19, 0.6) 40%, rgba(16, 18, 19, 0.6) 60%, rgba(16, 18, 19, 0) 100%), url(${snacks})`
                    }} >
                    <div
                        className="SuvaiAbout-inner-imageCont-header"
                    >
                        About Us

                    </div>
                </div>
            </div>
            <div className="SuvaiAbout-inner2">
                <div
                    className="SuvaiAbout-inner-imageCont"
                    style={{
                        backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${thali})`
                    }} >
                </div>
                <div className="SuvaiAbout-inner2-textContWarpper">
                    <div class="SuvaiAbout-inner2-textContWarpper-vertical">Elemental cooking methods</div>
                    <div className="SuvaiAbout-inner2-textContWarpper-textCont2"
                    >

                        <div
                            className="SuvaiAbout-inner2-textContWarpper-textCont2-header">
                            Food Philosophy
                        </div>
                        {rightCont.map((content, key) => <div
                            key={key}
                            dangerouslySetInnerHTML={{ __html: content?.text }}
                            className="SuvaiAbout-inner2-textContWarpper-textCont2-content" />)}
                    </div>
                </div>


            </div>
        </div>
    )
}
export default SuvaiAbout